import React from 'react';

import {
	LIVE_PAGE_SESSION_EXPERIENCE,
	EDIT_PAGE_EXPERIENCE,
	VIEW_PAGE_EXPERIENCE,
} from '@confluence/experience-tracker/entry-points/ExperienceName';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';

const livePageSessionCollect = (events, experience) => {
	const liveEditExperienceFailed = events.find(
		({ action, name }) => action === 'taskFail' && name === EDIT_PAGE_EXPERIENCE,
	);
	const liveEditExperienceAborted = events.find(
		({ action, name }) => action === 'taskAbort' && name === EDIT_PAGE_EXPERIENCE,
	);
	const liveViewExperienceFailed = events.find(
		({ action, name }) => action === 'taskFail' && name === VIEW_PAGE_EXPERIENCE,
	);
	const liveViewExperienceAborted = events.find(
		({ action, name }) => action === 'taskAbort' && name === VIEW_PAGE_EXPERIENCE,
	);

	if (liveEditExperienceFailed || liveViewExperienceFailed) {
		experience.fail({
			error: new Error(`Live page ${liveViewExperienceFailed ? 'view' : 'edit'} experience failed`),
		});
	} else if (liveEditExperienceAborted || liveViewExperienceAborted) {
		experience.abort({
			reason: `Live page ${liveViewExperienceAborted ? 'view' : 'edit'} experience aborted`,
		});
	}
};

export function LivePageSessionExperienceStart() {
	const { livePageReleasePhase } = useIsLivePagesFeatureEnabled();
	return (
		<ExperienceStart
			name={LIVE_PAGE_SESSION_EXPERIENCE}
			collect={livePageSessionCollect}
			// isLivePage is a necessary attribute because we check for this attribute when attempting to succeed
			// the live-page-session experience prior to route transition in startExperienceForRoute.ts
			attributes={{ livePageReleasePhase, isLivePage: true }}
		/>
	);
}
